import $ from "jquery"
import ScrollMagic from 'scrollmagic';

document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('.flow-link');
  const contents = document.querySelectorAll('.slide-scroll__item');

  links.forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();

      // Remove active class from all links and content sections
      links.forEach(l => l.classList.remove('active'));
      contents.forEach(content => {
        content.classList.remove('d-block', 'active');
        content.classList.add('d-none');
      });

      // Add active class to the clicked link
      this.classList.add('active');

      // Show the clicked content section
      const target = document.querySelector(this.getAttribute('data-target'));
      if (target) {
        target.classList.remove('d-none');
        target.classList.add('d-block', 'active');
      }
    });
  });
});

$(document).ready(function(){
  var $slider = $('.js-slider-default');

  // Function to update the slide counter
  function updateSliderCounter() {
    var slickInstance = $slider.slick('getSlick');
    if (!slickInstance) {
      return;
    }
    var currentSlideIndex = slickInstance.currentSlide + 1;
    var totalSlides = slickInstance.slideCount;
    $('.js-desktop-counter').text(currentSlideIndex + '/' + totalSlides);
  }

  // Initial counter update
  updateSliderCounter();

  // Update the counter after the slide changes
  $slider.on('afterChange', function(event, slick, currentSlide){
    updateSliderCounter();
  });

  // Update the counter when the slide layout changes
  $slider.on('setPosition', function(){
    updateSliderCounter();
  });

  // Prevent default behavior of navigation buttons
  $('.desktop-prev, .desktop-next').on('click', function(event){
    event.preventDefault();
  });
});
